import React from "react";

export const Badge = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_4189_44378)">
        <path
          d="M4.76036 7.58519L5.99958 6.83341L7.2388 7.58519L6.91006 6.17581L8.00914 5.22832L6.56276 5.10675L5.99958 3.77758L5.4364 5.10675L3.99002 5.22832L5.0891 6.17581L4.76036 7.58519ZM5.99958 10.6579L4.5611 9.23347H2.56208V7.23445L1.1377 5.79597L2.56208 4.35749V2.35847H4.5611L5.99958 0.934082L7.43806 2.35847H9.43708V4.35749L10.8615 5.79597L9.43708 7.23445V9.23347H7.43806L5.99958 10.6579ZM5.99958 9.6918L7.14541 8.54597H8.74958V6.9418L9.89541 5.79597L8.74958 4.65013V3.04597H7.14541L5.99958 1.90013L4.85375 3.04597H3.24958V4.65013L2.10375 5.79597L3.24958 6.9418V8.54597H4.85375L5.99958 9.6918Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4189_44378">
          <rect width="11" height="11" fill="white" transform="translate(0.5 0.295898)" />
        </clipPath>
      </defs>
    </svg>
  );
};
